<template>
  <div>
    <v-container fluid>
      <v-card elevation="0">
        <v-card-title
          class="text-h5 mb-2 text-start font-weight-bold text-primary"
        >
          {{ `Refund/Cancellation Policy` }}
        </v-card-title>
        <v-card-text class="text-start">
          <div class="mb-4 font-weight-semibold text-subtitle1 text-secondary">
            At <strong>Quizzr</strong>, we strive to deliver a high-quality and
            enjoyable quiz experience through our credit-based plans. Before
            making a purchase, we encourage users to carefully review the plan
            details. Below is our official refund and cancellation policy for
            all users.
          </div>
          <h3 class="mt-2">⁠💰 Refund Policy</h3>
          <div class="ps-8">
            <ol>
              <li>
                <div class="font-weight-semibold">
                  Digital Nature of Credits
                </div>
                <ul class="ms-6">
                  <li>
                    Credits purchased on Quizzr are digital goods and are
                    non-refundable once delivered to your account.
                  </li>
                </ul>
              </li>
              <li>
                <div>Refund Eligibility</div>

                <ul>
                  Refunds may only be issued under the following exceptional
                  conditions:
                  <div class="ms-6">
                    <li>
                      You were charged multiple times for the same transaction.
                    </li>
                    <li>
                      You did not receive credits within a reasonable timeframe
                      after successful payment.
                    </li>
                    <li>
                      You were charged an incorrect amount due to a technical
                      error.
                    </li>
                  </div>
                </ul>
                ⚠️ Refunds will not be provided for unused or partially used
                credits.
              </li>
            </ol>
          </div>
          <h3 class="mt-2">❌ Cancellation Policy</h3>
          <div class="px-8">
            <ul>
              <li>
                Quizzr operates on a pay-as-you-go model. Since there are no
                recurring subscriptions, there is no automatic renewal or
                cancellation requirement.
              </li>
              <li>
                Once a credit plan is purchased, it cannot be canceled, but you
                can use the remaining credits at any time.
              </li>
            </ul>
          </div>
          <h3 class="mt-2">ℹ️ Additional Notes</h3>
          <div class="px-8">
            <ul>
              <li>
                Credits do not expire and can be used at your convenience.
              </li>
              <li>
                Quizzr reserves the right to deny a refund request if any
                fraudulent activity or abuse of the platform is suspected.
              </li>
              <li>All refund decisions made by Quizzr are final.</li>
            </ul>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script></script>
